import React from "react";
import "@/animations/animate.css";

import AnimatedElements from "@/animations/AnimatedElement";
import AnimatedBody from "@/animations/AnimatedBody";
import { Ivy } from "@/fonts/spaceGrotesk";
import NoteLottie from "./notLottie";
import Badge from "@/components/ui/badge";
// @ts-ignore

const NoteComponent = ({certificate }: any) => {
    const ref = React.useRef(null)
   
    const [result, setResult] = React.useState<any>(null);
    const [not , setNot] = React.useState<any>(false);
   

    React.useEffect(() => {
    
        async function getdata() {
       
            
            const not = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/not?certificate=${certificate}`);
            const nots = await not.json();
const notdetay = nots.not
const gonderen = nots.gonderen
// if both are null then it is not valid else valid
if (notdetay == '' && gonderen == '') {
    setNot(false);
}
else {
    setNot(true);
}
            setResult(nots)
        }
    
        getdata();
    
    }
    , [])
    return (
        <>

{not && (        <section
            ref={ref}
            className="relative min-h-screen z-10 0 w-screen  items-center justify-center overflow-hidden bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
            id="NoteComponent"
        >
           




            <div className="mx-auto flex w-screen flex-row items-center justify-center lg:max-w-[1212.8px]">
            
            <div className="mx-auto flex w-screen flex-col md:flex-row   ">
                    <div className=" flex w-screen  flex-col  items-center justify-center  text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7]  md:text-[20px] md:leading-relaxed  lg:text-[24px] ">
                 <div 
               
                 >   <AnimatedElements>   
                    <NoteLottie />
                      </AnimatedElements>     
                      </div>
                    </div>
                    <div className="flex flex-col w-full justify-center items-center gap-2">
             <Badge>Başlamadan Önce...</Badge>       <AnimatedBody delay={0.2} className={`text-[3rem] mt-2  sm:text-[4.9rem] leading-none  font-normal text-center !text-opacity-100 !text-white-vibrant ${Ivy.className}`}
                    text={`Özel Birinden`} />
                     <AnimatedBody delay={0.2} className={`text-[3.5rem]  sm:text-[5.9rem] font-bold text-center !text-opacity-100 !text-white-vibrant `}
                    text={`Mesajın var`} />

                   <div className="w-80 h-80 rounded-full bg-opacity-30 bg-purple-500 blur-3xl absolute top-0 bottom-0 left-0 right-0 mx-auto my-auto"></div>

<div className="sm:p-5 sm:m-5 p-2 m-4 flex flex-col w-[90%] items-center justify-center rounded-xl bg-white ">
<AnimatedBody delay={0.2}
                    className="text-[1rem] max-w-[70%] sm:text-[1.5rem] font-medium text-center !text-opacity-100 !text-black"
                    text={`${result.not}`} />
                    <AnimatedBody delay={0.2}
                    className="text-[0.78rem] max-w-[70%] sm:text-[1rem] font-normal text-center !text-opacity-100 !text-black"
                    text={`${result.gonderen}`} />

</div>
</div>
                </div>
               
            </div>
        </section>)}
        </>
    );
};

export default NoteComponent;
